(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-assurance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepare = (root) => {
      if (root.dataset.sdaReady) return;
      root.dataset.sdaReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      observer.observe(root);
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-sda]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-concierge-guard"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepare = (guard) => {
      if (guard.dataset.sdgReady) return;
      guard.dataset.sdgReady = 'true';

      let variants;
      try {
        variants = JSON.parse(guard.querySelector('[data-sdg-variants]').textContent);
      } catch (error) {
        return;
      }

      const threshold = Number(guard.dataset.threshold);
      const productSection = document.querySelector('[id^="SarattiLookbookProduct-"]');
      const form = productSection?.querySelector('.saratti-lb-form');
      const addButton = productSection?.querySelector('.saratti-lb-add');
      const inquiry = productSection?.querySelector('.saratti-lb-inquiry');
      const variantInput = form?.querySelector('input[name="id"]');

      if (!productSection || !form || !addButton || !inquiry || !variantInput) return;

      const note = document.createElement('div');
      note.className = 'saratti-lb-concierge-note';
      note.innerHTML = guard.querySelector('[data-sdg-message]').innerHTML;
      note.hidden = true;
      inquiry.insertAdjacentElement('afterend', note);

      const update = () => {
        const variant = variants.find((item) => String(item.id) === String(variantInput.value));
        const isHighValue = Boolean(variant && Number(variant.price) > threshold);
        productSection.classList.toggle('saratti-lb-high-value', isHighValue);
        addButton.hidden = isHighValue;
        note.hidden = !isHighValue;
      };

      form.addEventListener('submit', (event) => {
        const variant = variants.find((item) => String(item.id) === String(variantInput.value));
        if (variant && Number(variant.price) > threshold) {
          event.preventDefault();
          event.stopImmediatePropagation();
          inquiry.click();
        }
      }, true);

      document.addEventListener('change', update);
      document.addEventListener('product:variant-change', update);
      new MutationObserver(update).observe(variantInput, { attributes: true, attributeFilter: ['value', 'disabled'] });
      update();
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-sdg]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-selection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepare = (root) => {
      if (root.dataset.sdjReady) return;
      root.dataset.sdjReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });
      observer.observe(root);
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-sdj]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-standard"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepare = (root) => {
      if (root.dataset.sdsReady) return;
      root.dataset.sdsReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18 });
      observer.observe(root);

      root.querySelectorAll('[data-sds-info]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = document.getElementById(button.dataset.sdsInfo);
          if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        });
      });

      root.querySelectorAll('[data-sds-dialog]').forEach((dialog) => {
        const closeButton = dialog.querySelector('[data-sds-close]');
        if (closeButton) closeButton.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-sds]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepare = (root) => {
      if (root.dataset.sdyReady) return;
      root.dataset.sdyReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      observer.observe(root);
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-sdy]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-perfect-match"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');

    const category = (name) => {
      const value = normalize(name);
      if (value.includes('metal') && (value.includes('color') || value.includes('colour'))) return 'metalcolor';
      if (value.includes('metal') && value.includes('type')) return 'metaltype';
      if (value.includes('ringsize') || value === 'size') return 'size';
      return value;
    };

    const selections = () => {
      const selected = {};
      document.querySelectorAll('form[action*="/cart/add"] select[name], form[action*="/cart/add"] input[name]:checked').forEach((field) => {
        const rawName = field.name.replace(/^options\[/, '').replace(/^properties\[/, '').replace(/\]$/, '');
        if (!field.value) return;
        selected[normalize(rawName)] = field.value;
        selected[category(rawName)] = field.value;
      });
      return selected;
    };

    const updateCard = (card, current) => {
      const optionsNode = card.querySelector('[data-match-options]');
      const variantsNode = card.querySelector('[data-match-variants]');
      if (!optionsNode || !variantsNode) return;

      let optionNames;
      let variants;
      try {
        optionNames = JSON.parse(optionsNode.textContent);
        variants = JSON.parse(variantsNode.textContent);
      } catch (error) {
        return;
      }

      const match = variants.find((variant) => {
        if (!variant.available) return false;
        return optionNames.every((name, index) => {
          const chosen = current[normalize(name)] || current[category(name)];
          return !chosen || normalize(variant.options[index]) === normalize(chosen);
        });
      });

      if (!match) return;
      card.querySelectorAll('[data-match-link]').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', match.id);
        link.href = url.toString();
      });
    };

    const prepare = (root) => {
      if (root.dataset.smpReady) return;
      root.dataset.smpReady = 'true';

      const refresh = () => {
        const current = selections();
        root.querySelectorAll('[data-match-card]').forEach((card) => updateCard(card, current));
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      observer.observe(root);
      document.addEventListener('change', refresh);
      refresh();
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-smp]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
